module.exports = __webpack_public_path__ + "img/info-icon.95ee2fb5.svg";